import * as React from 'react';
import { GuestCard } from '../../../../../api/TourSignup';
import ProspectProfileDisplay from './ProspectProfileDisplay';
import ProspectPreferenceDisplay from './ProspectPreferenceDisplay';

interface Props {
    guestCard: GuestCard;
}

const GuestCardDisplay = (props: Props) => {
    return (
        <div>
            <ProspectProfileDisplay guestCard={props.guestCard} />
            <div className="sub-section-header">
                <b>Preferences: </b>
            </div>
            <ProspectPreferenceDisplay
                preferences={props.guestCard.preferences}
                unitTypeDescription={props.guestCard.unitType.description}
            />
        </div>
    );
};

export default GuestCardDisplay;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/display/GuestCardDisplay.tsx